export { ADMIN_TRANSLATION_NAMESPACE } from "../../config";

export const NON_REG_VIEW_TK = "NON_REG_VIEW_TK";

// NL
export const NEWSLETTER_TRANSLATION_NAMESPACE = "newsletter";
export const NEWSLETTER_VIEW_TK = "NEWSLETTER_VIEW_TK";
